(function () {
  if (window.__IG_ID15_LOADED__) return;
  window.__IG_ID15_LOADED__ = true;

  var CLASS_NAME = "ig-id15-a";
  var scheduled = null;

  function isActive() {
    return document.documentElement.classList.contains(CLASS_NAME);
  }

  function markFoundersCards() {
    if (!isActive()) return;
    document.querySelectorAll(".grid-imagebox").forEach(function (box) {
      if (box.hasAttribute("data-founders-pick")) return;
      var text = (box.textContent || "").replace(/\s+/g, " ");
      if (/founders?\s*pick/i.test(text)) {
        box.setAttribute("data-founders-pick", "true");
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      markFoundersCards();
    });
  }

  function boot() {
    schedule();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
